import styled from 'styled-components';

export const VisitDetailsModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`;

export const VisitDetailsModalContainer = styled.div`
  background-color: #ffffff;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  padding: 24px;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const InAnalysisModalContainer = styled.div`
  background-color: #ffffff;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  padding: 24px;

  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const VisitDetailsModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const VisitDetailsModalTitle = styled.h2`
  font-family: 'Mangueira';
  font-size: 20px;
  font-weight: 700;
  color: #3D3D3D;
  margin: 0;
`;

export const VisitDetailsCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  color: #636363;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const VisitDetailsStatusBadge = styled.div`
  background-color: ${props => {
    switch(props.status) {
      case 'Realizado': return '#EAF7EE';
      case 'Em análise': return '#F8F2FF';
      case 'Cancelado': return '#FCEDE9';
      case 'Agendada': return '#FFF3DC';
      default: return '#F0F0F0';
    }
  }};
  color: ${props => {
    switch(props.status) {
      case 'Realizado': return '#3DA464';
      case 'Em análise': return '#6703E1';
      case 'Cancelado': return '#E74141';
      case 'Agendada': return '#ED9500';
      default: return '#636363';
    }
  }};
  padding: 4px 12px;
  border-radius: 16px;
  font-family: 'Mangueira';
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  margin-bottom: 20px;
`;

export const InAnalysisStatusBadgeOrange = styled.div`
  background-color: #FFF3DC;
  color: #ED9500;
  padding: 4px 12px;
  border-radius: 16px;
  font-family: 'Mangueira';
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  margin-bottom: 20px;
`;

export const NotRealizedStatusBadge = styled.div`
  background-color: #FCEDE9;
  color: #E74141;
  padding: 4px 12px;
  border-radius: 16px;
  font-family: 'Mangueira';
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  margin-bottom: 20px;
`;

export const ConfirmedInfoBox = styled.div`
  border: 2px solid #CBCBCB;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
  background-color: #FFFFFF;
`;

export const ConfirmedIconContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
`;

export const ConfirmedMessage = styled.p`
  font-family: 'Mangueira';
  font-size: 14px;
  color: #636363;
  text-align: center;
  line-height: 1.5;
  margin: 0;
`;

export const NotRealizedInfoBox = styled.div`
  border: 2px solid #E5E5E5;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 24px;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const NotRealizedIconContainer = styled.div`
  margin-bottom: 16px;
`;

export const NotRealizedMessage = styled.p`
  font-family: 'Mangueira';
  font-size: 14px;
  color: #636363;
  line-height: 1.5;
  margin: 0 0 16px 0;
`;

export const VisitDetailsSection = styled.div`
  margin-bottom: 24px;
  padding: 16px;
  border: 1px solid #E5E5E5;
  border-radius: 8px;
  background: #FFFFFF;
`;

export const VisitDetailsSectionTitle = styled.h3`
  font-family: 'Mangueira';
  font-size: 16px;
  font-weight: 700;
  color: #3D3D3D;
  margin: 0 0 12px 0;
`;

export const VisitDetailsSummaryItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
`;

export const VisitDetailsSummaryIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
`;

export const VisitDetailsSummaryContent = styled.div`
  flex: 1;
`;

export const VisitDetailsSummaryLabel = styled.div`
  font-family: 'Mangueira';
  font-size: 12px;
  color: #636363;
  margin-bottom: 2px;
`;

export const VisitDetailsSummaryValue = styled.div`
  font-family: 'Mangueira';
  font-size: 14px;
  font-weight: 500;
  color: #3D3D3D;
`;

export const VisitDetailsRatingSection = styled.div`
  text-align: center;
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid #E5E5E5;
  border-radius: 8px;
  background: #FFFFFF;
`;

export const VisitDetailsRatingNumber = styled.div`
  font-family: 'Mangueira';
  font-size: 32px;
  font-weight: 700;
  color: #3D3D3D;
  margin-bottom: 8px;
`;

export const VisitDetailsRatingStars = styled.div`
  display: flex;
  justify-content: center;
  gap: 4px;
  margin-bottom: 8px;
`;

export const VisitDetailsRatingText = styled.div`
  font-family: 'Mangueira';
  font-size: 14px;
  color: #CBCBCB;
`;

export const RatingStarImage = styled.img`
  filter: ${props => props.isActive ? 'none' : 'grayscale(100%) brightness(0.9)'};
  opacity: ${props => props.opacity || 1};
  cursor: ${props => props.onClick ? 'pointer' : 'default'};
  transition: filter 0.2s ease;

  &:hover {
    filter: ${props => props.onClick ? 'none' : props.isActive ? 'none' : 'grayscale(100%) brightness(0.9)'};
  }
`;

export const VisitDetailsTagsContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  padding: 12px;
  background: #FFFFFF;
  border-radius: 6px;
`;

export const VisitDetailsTag = styled.span`
  background-color: #F0F0F0;
  color: #636363;
  padding: 6px 12px;
  border-radius: 16px;
  font-family: 'Mangueira';
  font-size: 12px;
  font-weight: 500;
`;

export const EvaluationFormContainer = styled.div`
  margin-top: 20px;
  padding: 16px;
`;

export const EvaluationFormTitle = styled.div`
  font-family: 'Mangueira';
  font-size: 16px;
  font-weight: 700;
  color: #3D3D3D;
  margin-bottom: 12px;
`;

export const EvaluationTextarea = styled.textarea`
  width: 100%;
  min-height: 80px;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;

  &:focus {
    border-color: #6703E1;
  }

  &::placeholder {
    color: #CBCBCB;
    font-family: 'Mangueira';
    font-size: 14px;
  }
`;

export const EvaluationButtonsContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 20px;
  justify-content: center;
  align-items: center;
`;

export const EvaluationCancelButton = styled.button`
  width: 140px;
  height: 48px;
  background-color: #FFFFFF;
  border: 1px solid #0B29FB;
  border-radius: 5px;
  font-family: 'Mangueira';
  font-size: 16px;
  font-weight: 700;
  color: #0B29FB;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f8f9ff;
  }

  &:active {
    transform: translateY(1px);
  }
`;

export const EvaluationSubmitButton = styled.button`
  width: 140px;
  height: 48px;
  background-color: #0B29FB;
  border: 1px solid #0B29FB;
  border-radius: 5px;
  font-family: 'Mangueira';
  font-size: 16px;
  font-weight: 700;
  color: #FFFFFF;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background-color: #0920d9;
  }

  &:active {
    transform: translateY(1px);
  }
`;

export const VisitSummaryText = styled.div`
  font-size: 12px;
  font-family: 'Mangueira';
  font-weight: 500;
  color: #3D3D3D;
  line-height: 1.542;
  margin-top: 12px;
`;

export const PlanContainer = styled.div`
  margin-top: 12px;
`;

export const PlanTitle = styled.div`
  font-family: 'Mangueira';
  font-size: 12px;
  font-weight: 700;
  color: #3D3D3D;
  margin-bottom: 8px;
  line-height: 1.542;
`;

export const PlanText = styled.div`
  font-size: 12px;
  font-family: 'Mangueira';
  font-weight: 500;
  color: #3D3D3D;
  line-height: 1.542;
  margin-bottom: 16px;
`;

export const PlanDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #CBCBCB;
  margin-bottom: 16px;
`;

export const VisitTagsContainerCustom = styled(VisitDetailsTagsContainer)`
  margin-top: 16px;
  margin-bottom: 0;
`;

export const VisitSectionSpaced = styled(VisitDetailsSection)`
  margin-top: 16px;
`;

export const RatingStarImageClickable = styled(RatingStarImage)`
  cursor: ${props => props.hasExistingRating ? 'default' : 'pointer'};
  transition: transform 0.1s ease;

  &:hover {
    transform: ${props => props.hasExistingRating ? 'none' : 'scale(1.1)'};
  }

  &:active {
    transform: ${props => props.hasExistingRating ? 'none' : 'scale(0.95)'};
  }

`;

export const ToggleButton = styled.button`
  background: none;
  border: none;
  color: #0B29FB;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  padding: 0;
  margin-top: 8px;
  transition: all 0.2s ease;

  &:hover {
    text-decoration: underline;
  }
`;

export const AttentionTitle = styled.h3`
  font-family: 'Mangueira';
  font-size: 16px;
  font-weight: 700;
  color: #3D3D3D;
  margin: 24px 0 12px 0;
  text-align: center;
`;

export const LegalText = styled.div`
  font-family: 'Mangueira';
  font-size: 12px;
  color: #636363;
  line-height: 1.6;
  margin-bottom: 24px;
  padding: 16px;
  border: 1px solid #E5E5E5;
  border-radius: 8px;
  background-color: #FAFAFA;
`;

export const EvaluationFormContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -24px;
`;

export const EvaluationRequiredSpan = styled.span`
  color: #FF0000;
`;

export const EvaluationTextareaWrapper = styled.div`
  max-width: 100%;
  width: 100%;
`;

export const EvaluationCharCounterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  width: 100%;
`;

export const EvaluationValidationLeft = styled.div``;

export const EvaluationValidationMessage = styled.div`
  color: ${props => props.$isError ? '#FF0000' : '#636363'};
  font-size: 12px;
  margin-bottom: 4px;
`;

export const EvaluationCharCount = styled.div`
  color: #636363;
  font-size: 12px;
`;

export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
`;
